import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { EmpresaService } from '../../../../../services/empresa.service';
import { Empresa } from '../../../../../models/empresa.model';
import { Util } from '../../../../shared/util';
import { WebPage } from '../../../../shared/web-page';
import { InscricaoService } from '../../../../../services/inscricao.service';
import { Categoria } from '../../../../../models/categoria';

@Component({
  selector: 'cadastro-empresa',
  templateUrl: './cadastro-empresa.component.html',
  styleUrls: ['./cadastro-empresa.component.css']
})
export class CadastroEmpresaComponent extends WebPage implements OnInit {
  items: MenuItem[];
  activeIndex: number = 0;
  
  empresaForm: FormGroup;
  
  listaTipoEmpresas: any[];
  listaTipoSetores: any[];

  estados: any[];
  estadosVaga: any[];
  cidadesPorEstado;
  cidades: any[];
  cidadesVaga;
  categorias: Categoria[] = [];
  categoriasSelecionadas: string[] = [];

  public empresa: any;
  public tipoDocumentoCnpj: string = 'cnpj'; // padrão inicial
  public tipoDocumentoCpf: string = 'cpf'; // padrão inicial
  public isEmpresaSigop: boolean = false;

  public isLoadingCep = false;

  public idFase;
  constructor(
    private fb: FormBuilder,
    private _empresaService: EmpresaService,
    messageService: MessageService,
    private _router: Router,
    private route: ActivatedRoute,
    private _insricaoService: InscricaoService,
  ) {
    super(messageService);
    this.route.paramMap.subscribe(params =>
      this.idFase = params.get('idFase')
    );
   }
  
  ngOnInit() {
    this.items = [
      {label: 'Dados da Empresa'},
      {label: 'Endereço da Empresa'},
      {label: 'Dados do Responsável'},
      {label: 'Dados da Vaga'}
    ];
    
    this.listaTipoEmpresas = [];
        
    this.listaTipoSetores = [];
    
    this.estados = [
      {label: 'Acre', value: 'AC'},
      {label: 'Alagoas', value: 'AL'},
      {label: 'Amapá', value: 'AP'},
      {label: 'Amazonas', value: 'AM'},
      {label: 'Bahia', value: 'BA'},
      {label: 'Ceará', value: 'CE'},
      {label: 'Distrito Federal', value: 'DF'},
      {label: 'Espírito Santo', value: 'ES'},
      {label: 'Goiás', value: 'GO'},
      {label: 'Maranhão', value: 'MA'},
      {label: 'Mato Grosso', value: 'MT'},
      {label: 'Mato Grosso do Sul', value: 'MS'},
      {label: 'Minas Gerais', value: 'MG'},
      {label: 'Pará', value: 'PA'},
      {label: 'Paraíba', value: 'PB'},
      {label: 'Paraná', value: 'PR'},
      {label: 'Pernambuco', value: 'PE'},
      {label: 'Piauí', value: 'PI'},
      {label: 'Rio de Janeiro', value: 'RJ'},
      {label: 'Rio Grande do Norte', value: 'RN'},
      {label: 'Rio Grande do Sul', value: 'RS'},
      {label: 'Rondônia', value: 'RO'},
      {label: 'Roraima', value: 'RR'},
      {label: 'Santa Catarina', value: 'SC'},
      {label: 'São Paulo', value: 'SP'},
      {label: 'Sergipe', value: 'SE'},
      {label: 'Tocantins', value: 'TO'}
    ];
    
    this.cidadesPorEstado = {
        // 'CE': [
        //   { value: 'FOR', label: 'Fortaleza' },
        //   { value: 'JUA', label: 'Juazeiro do Norte' },
        //   { value: 'SOB', label: 'Sobral' },
        //   { value: 'CRA', label: 'Crato' }
        // ],
        // 'SP': [
        //   { value: 'SAO', label: 'São Paulo' },
        //   { value: 'CAM', label: 'Campinas' },
        //   { value: 'SAN', label: 'Santos' },
        //   { value: 'RIB', label: 'Ribeirão Preto' }
        // ],
        // 'RJ': [
        //   { value: 'RIO', label: 'Rio de Janeiro' },
        //   { value: 'NIT', label: 'Niterói' },
        //   { value: 'PET', label: 'Petrópolis' },
        //   { value: 'MAC', label: 'Macaé' }
        // ],
        // 'MG': [
        //   { value: 'BH', label: 'Belo Horizonte' },
        //   { value: 'UBE', label: 'Uberlândia' },
        //   { value: 'JF', label: 'Juiz de Fora' },
        //   { value: 'CON', label: 'Contagem' }
        // ],
        // 'DF': [
        // {label: 'Brasília', value: 'Brasília'},
        // {label: 'Taguatinga', value: 'Taguatinga'},
        // {label: 'Ceilândia', value: 'Ceilândia'}
        // ]
      // Adicionar cidades para outros estados conforme necessário
    };
    this.carregarTipos();
    this.carregarCategorias();
    this.createForm();
    this.getChangeCnpj();
    this.getChangeCpf();
    this.estadosVaga = this.estados;

    // Monitora mudanças no tipo de documento para atualizar validações
    try{
      this.empresaForm.get('tipoDocumentoCnpj').valueChanges.subscribe(tipo => {
        this.tipoDocumentoCnpj = tipo;
        this.empresa.get('cnpj').updateValueAndValidity();
      });
    }catch{}
    try{
      this.empresaForm.get('tipoDocumentoCpf').valueChanges.subscribe(tipo => {
        this.tipoDocumentoCpf = tipo;
        this.empresa.get('cpf').updateValueAndValidity();
      });
    }catch{}
  }
  
  carregarTipos(){
    this._empresaService.getListaTipoEmpresa().subscribe(
      response => {
        if(response){
          //console.log(response);
          this.listaTipoEmpresas = response.map((x) => {
            return {label: x.descricao, value: x.idTipoEmpresa}
          })
        }
      },
      error => {
        console.error(error);
      }
    )
    this._empresaService.getListaTipoSetor().subscribe(
      response => {
        if(response){
          //console.log(response);
          this.listaTipoSetores = response.map((x) => {
            return {label: x.descricao, value: x.idTipoSetor}
          })
        }
      },
      error => {
        console.error(error);
      }
    )
  }
  carregarCategorias(){
    this._insricaoService.getListaCategoria().subscribe(
      response => {
        if(response){
          this.categorias = response.filter(c => c.idCategoria.toUpperCase() !== '4B3B98B5-6DDA-492E-AFBD-FBAAB06E01E2');
        }
      }
    )
  }
  createForm() {
    this.empresaForm = this.fb.group({
      // Passo 1: Dados da Empresa
      dadosEmpresa: this.fb.group({
        cnpj: ['', [Validators.required, Validators.pattern(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/), this.documentoValidatorCnpj()]],
        razaoSocial: ['', Validators.required],
        nomeFantasia: ['', Validators.required],
        telefone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        idTipoEmpresa: ['', Validators.required],
        idTipoSetor: ['', Validators.required],
      }),
      
      // Passo 2: Endereço da Empresa
      enderecoEmpresa: this.fb.group({
        cep: ['', Validators.required],
        uf: ['', Validators.required],
        cidade: ['', Validators.required],
        logradouro: ['', Validators.required],
        numero: ['', Validators.required],
        bairro: ['', Validators.required]
      }),
      
      // Passo 3: Dados do Responsável
      dadosResponsavel: this.fb.group({
        cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/), this.documentoValidatorCpf()]],
        responsavelNome: ['', Validators.required],
        responsavelCargo: ['', Validators.required],
        responsavelEmail: ['', [Validators.required, Validators.email]],
        responsavelTelefone: ['', Validators.required]
      }),
      estadoVaga: [''],
      cidadeVaga: [''],
      numeroVagas: [''],

      // Passo 4: Dados da Vaga
      vagas: this.fb.array([])
    });
  }
  getChangeCnpj(){
    // Acompanhar as mudanças no campo CPF e aplicar a máscara
    this.empresaForm.get('dadosEmpresa.cnpj').valueChanges.subscribe(value => {
      if (value) {
        // Remove caracteres não numéricos
        let numericValue = value.replace(/\D/g, '');
        
        // Limita a 11 dígitos (CPF)
        numericValue = numericValue.substring(0, 14);
        
        // Aplica a máscara CPF (XXX.XXX.XXX-XX)
        let maskedValue = numericValue;
        
        if (numericValue.length > 2) {
          maskedValue = numericValue.substring(0, 2) + '.' + numericValue.substring(2);
        }
        
        if (numericValue.length > 6) {
          maskedValue = maskedValue.substring(0, 6) + '.' + maskedValue.substring(6);
        }

        if (numericValue.length > 9) {
          maskedValue = maskedValue.substring(0, 10) + '/' + maskedValue.substring(10);
        }

        if (numericValue.length > 12) {
          maskedValue = maskedValue.substring(0, 15) + '-' + maskedValue.substring(15);
        }        
        // Atualiza o campo com o valor mascarado sem disparar outro evento valueChanges
        this.empresaForm.get('dadosEmpresa.cnpj').setValue(maskedValue, { emitEvent: false });
      }
    });
  }
  getChangeCpf(){
    // Acompanhar as mudanças no campo CPF e aplicar a máscara
    this.empresaForm.get('dadosResponsavel.cpf').valueChanges.subscribe(value => {
      if (value) {
        // Remove caracteres não numéricos
        let numericValue = value.replace(/\D/g, '');
        
        // Limita a 11 dígitos (CPF)
        numericValue = numericValue.substring(0, 11);
        
        // Aplica a máscara CPF (XXX.XXX.XXX-XX)
        let maskedValue = numericValue;
        
        if (numericValue.length > 3) {
          maskedValue = numericValue.substring(0, 3) + '.' + numericValue.substring(3);
        }
        
        if (numericValue.length > 6) {
          maskedValue = maskedValue.substring(0, 7) + '.' + maskedValue.substring(7);
        }
        
        if (numericValue.length > 9) {
          maskedValue = maskedValue.substring(0, 11) + '-' + maskedValue.substring(11);
        }
        
        // Atualiza o campo com o valor mascarado sem disparar outro evento valueChanges
        this.empresaForm.get('dadosResponsavel.cpf').setValue(maskedValue, { emitEvent: false });
      }
    });
  }
  get vagasArray(): FormArray {
    return this.empresaForm.get('vagas') as FormArray;
  }
  
  createVaga(): FormGroup {
    return this.fb.group({
      estado: ['', Validators.required],
      cidade: ['', Validators.required],
      quantidade: ['', [Validators.required, Validators.min(1)]],
      categorias: [[]],
    });
  }
  
  adicionarVaga(dados: any) {
    // console.log(this.vagasArray);
    // console.log(this.empresaForm.controls.vagas);
    if(dados){
      if(dados.quantidade != undefined && dados.quantidade != null && dados.quantidade != '' && dados.quantidade > 0
         && dados.cidade != undefined && dados.cidade != null && dados.cidade != ''
         && dados.estado != undefined && dados.estado != null && dados.estado != ''
         && dados.categorias.length > 0){

           let isInvalida = false;
             this.vagasArray.value.map((v) => {
               if(v.estado == this.empresaForm.controls.estadoVaga.value && v.cidade == this.empresaForm.controls.cidadeVaga.value){
                 alert('Vaga já existente para esse estado e cidade');
                 isInvalida = true;
               }
             })
             if(isInvalida){ return;} else {
               var c = [];
               c.push(... dados.categorias);
               const novaVaga = this.fb.group({
                 estado: [dados.estado || ''],
                 cidade: [dados.cidade || ''],
                 quantidade: [dados.quantidade || 0],
                 categorias: [ c || []]
               });
           
               this.vagasArray.push(novaVaga);
             }
           }        
        }
  }
  
  removerVaga(index: number) {
    this.vagasArray.removeAt(index);
  }
  
  avancar() {
    if (this.validateCurrentStep()) {
      this.activeIndex++;
    }
  }
  
  voltar() {
    this.activeIndex--;
  }
  
  validateCurrentStep(): boolean {
    let currentForm: FormGroup;
    
    switch(this.activeIndex) {
      case 0:
        currentForm = this.empresaForm.get('dadosEmpresa') as FormGroup;
        break;
      case 1:
        currentForm = this.empresaForm.get('enderecoEmpresa') as FormGroup;
        break;
      case 2:
        currentForm = this.empresaForm.get('dadosResponsavel') as FormGroup;
        break;
      case 3:
        // Validar se há pelo menos uma vaga cadastrada
        return this.vagasArray.length > 0;
      default:
        return true;
    }
    
    if (currentForm.valid) {
      return true;
    } else {
      // Marcar todos os campos como touched para mostrar erros
      Object.keys(currentForm.controls).forEach(field => {
        const control = currentForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return false;
    }
  }
  onCepChange(event) {
    const cep = event.target.value;
    if(cep){
      this.isLoadingCep = true;
      this._insricaoService.getEnderecoByCepSest(Util.limpaCep(cep)).subscribe(
        response => {
          //console.log(response);
          this.carregarCidades(response.uf);
          this.aguarde();
          this.empresaForm.patchValue({
            enderecoEmpresa: {
              logradouro: response.logradouro,
              uf: response.uf,
              cidade: response.cidade,
              bairro: response.bairro,
            }
          })
        },
        error => {
          console.error(error);
        },
        () => {
          this.isLoadingCep = false;
        }
      )
    }
  }
  onEstadoChange(event, vagaIndex = null) {
    const estado = event.value;
    // Aqui você pode carregar as cidades com base no estado selecionado
    // Para fins de demonstração, estamos usando a lista estática definida no ngOnInit
    const estadoValue = event.value;
    //console.log(estadoValue);
    // Carregar cidades correspondentes ao estado
    if(estadoValue){
      this.carregarCidades(estadoValue);
    }
    // if (estadoValue && this.cidadesPorEstado[estadoValue]) {
    //   this.cidades = this.cidadesPorEstado[estadoValue];
    //   console.log(this.cidades);
    // } else {
    //   this.cidades = [];
    // }
  }
  carregarCidades(uf){
    this._insricaoService.getCidadesByUfSest(uf).subscribe(
      response => {
        //console.log(response);
        this.cidades = response.map((x) => {
          return {label: x.nome, value: x.nome}
        })
      },
      error => {
        console.error(error);
      }
    );
  }
  onEstadoVagaChange(event, vagaIndex = null) {
    const estado = event.value;
    // Aqui você pode carregar as cidades com base no estado selecionado
    // Para fins de demonstração, estamos usando a lista estática definida no ngOnInit
    const estadoValue = event.value;
    //console.log(estadoValue);
    if(estadoValue){
      this._insricaoService.getCidadesByUfSest(estadoValue).subscribe(
        response => {
          //console.log(response);
          this.cidadesVaga = response.map((x) => {
            return {label: x.nome, value: x.nome}
          })
        },
        error => {
          console.error(error);
        }
      );
    }
    // if (estadoValue && this.cidadesPorEstado[estadoValue]) {
    //   this.cidades = this.cidadesPorEstado[estadoValue];
    //   console.log(this.cidades);
    // } else {
    //   this.cidades = [];
    // }
  }
  // No seu componente
  getEstadoLabel(estadoValue: any): string {
    const estado = this.estados.find(e => e.value === estadoValue);
    return estado ? estado.label : '';
  }
  
  submitForm() {
    // Para se o formulário estiver inválido
    if (this.empresaForm.invalid) {
      return;
    }

    if (this.empresaForm.valid) {
      //console.log('Form submitted:', this.empresaForm.value);
      this.empresa = {
        idEmpresa: '00000000-0000-0000-0000-000000000000',
        cnpj : Util.limpaCnpj(this.empresaForm.value.dadosEmpresa.cnpj),
        razaoSocial : this.empresaForm.value.dadosEmpresa.razaoSocial,
        nomeFantasia : this.empresaForm.value.dadosEmpresa.nomeFantasia,
        telefone: this.empresaForm.value.dadosEmpresa.telefone,
        email: this.empresaForm.value.dadosEmpresa.email,
        
        cpf: Util.limpaCpf(this.empresaForm.value.dadosResponsavel.cpf),
        responsavelNome: this.empresaForm.value.dadosResponsavel.responsavelNome,
        responsavelCargo: this.empresaForm.value.dadosResponsavel.responsavelCargo,
        responsavelTelefone: this.empresaForm.value.dadosResponsavel.responsavelTelefone,
        responsavelEmail: this.empresaForm.value.dadosResponsavel.responsavelEmail,
        
        cep: Util.limpaCep(this.empresaForm.value.enderecoEmpresa.cep),
        uf: this.empresaForm.value.enderecoEmpresa.uf,
        cidade: this.empresaForm.value.enderecoEmpresa.cidade,
        logradouro: this.empresaForm.value.enderecoEmpresa.logradouro,
        numero: this.empresaForm.value.enderecoEmpresa.numero,
        bairro: this.empresaForm.value.enderecoEmpresa.bairro,
        
        idTipoEmpresa: this.empresaForm.value.dadosEmpresa.idTipoEmpresa,
        idTipoSetor: this.empresaForm.value.dadosEmpresa.idTipoSetor,
      }
      this.isLoading = true;
      this.empresa.vagas = this.vagasArray.value.map((v) => {
        let cats = [];
        v.categorias.forEach((cat) =>{
          cats.push(... this.categorias.filter(c => c.idCategoria == cat));
        });
        return {
          idVaga: '00000000-0000-0000-0000-000000000000',
          idEmpresa: '00000000-0000-0000-0000-000000000000',
          uf: v.estado, cidade: v.cidade, numeroVagas: v.quantidade,
          categorias : cats,
          idFase: this.idFase,
        }
      })
      this._empresaService.inserirEmpresa(this.empresa)
      .finally(() => this.isLoading = false)  
      .subscribe(
          (response) => {
            //console.log(response);
            // Aqui você chamaria seu serviço para enviar os dados ao backend
            //alert('Cadastro Realizado com Sucesso!');
            //this.resetForm();
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro Realizado com Sucesso!' });
            this._empresaService.getSigopByCnpj(this.empresa.cnpj).subscribe(
              (data) => {
                if(data){
                  this._router.navigate(['cadastro/sucesso']);
                }else{
                  this._router.navigate(['cadastro/analise']);
                }
              }
            );
          },
          (error) => {
            console.error(error);
            //alert(`Falha ao realizar Cadastro! \n ${error.message}`);
            this.messageService.add({ severity: 'error', summary: 'Atenção', detail: `Falha ao realizar Cadastro! \n ${error.message}` });
            //this._router.navigate(['cadastro/analise']);
          }
        )
    } else {
      console.log('Form is invalid');
    }
  }
  
  resetForm() {
    this.empresaForm.reset();
    while (this.vagasArray.length !== 0) {
      this.vagasArray.removeAt(0);
    }
    this.activeIndex = 0;
  }

  // Validador personalizado que escolhe entre CPF ou CNPJ com base no tipo selecionado
  documentoValidatorCnpj() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      
      if (!value) {
        return null;
      }

      // Remove caracteres não numéricos para validação
      const numeros = value.replace(/\D/g, '');
      // Verifica qual validação aplicar com base no tipo de documento selecionado
      if (this.tipoDocumentoCnpj === 'cnpj') {
        return Util.isCnpj(numeros) ? null : { cnpjInvalido: true };
      }
    };
  }
  documentoValidatorCpf() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      
      if (!value) {
        return null;
      }

      // Remove caracteres não numéricos para validação
      const numeros = value.replace(/\D/g, '');
      // Verifica qual validação aplicar com base no tipo de documento selecionado
      if (this.tipoDocumentoCpf === 'cpf') {
        return Util.isCpf(numeros) ? null : { cpfInvalido: true };
      }
    };
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  // Exemplo de uso:
  async  aguarde() {
    console.log("Antes de dormir");
    await this.sleep(2000); // Pausa por 2000 milissegundos (2 segundos)
    console.log("Depois de dormir");
  }
  
  // Método para select múltiplo nativo
  onCategoriasChange(event: any) {
    const selectedOptions = Array.from(event.target.selectedOptions);
    this.categoriasSelecionadas.push(... selectedOptions.map((option: any) => option.value));
  }

  // Método para checkboxes
  onCheckboxChange(event: any, categoria: Categoria) {
    if (event.target.checked) {
      // Adicionar categoria se não estiver na lista
      if (!this.categoriasSelecionadas.includes(categoria.idCategoria)) {
        this.categoriasSelecionadas.push(categoria.idCategoria);
      }
    } else {
      // Remover categoria da lista
      this.categoriasSelecionadas = this.categoriasSelecionadas.filter(
        id => id !== categoria.idCategoria
      );
    }
  }

  // Verificar se uma categoria está selecionada
  isCategoriaSelecionada(categoriaId: string): boolean {
    return this.categoriasSelecionadas.includes(categoriaId);
  }

  getDescricaoCategoria(value){
    return this.categorias.find(categoria => categoria.idCategoria === value).descricao;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/empresa/cadastro/cadastro-empresa.component.ts